import React from 'react';
import { Devtools } from './Devtools';
import { Switch } from '../components/shared/Switch';
import { BaseDialog } from '../components/layout/Dialog';
import { connect } from 'react-redux';
import { hideDevtools, showDevtools } from '../actions/dialog';

class DevtoolsDialog extends React.Component {

  devtoolsSecretCode = [];
  onKeyDown = ($event) => {
    const devtoolsSecretCode = this.devtoolsSecretCode;
    // Type the code
    switch (($event.key || '').toLowerCase()) {
      case '-':
      case 'p':
      case 'o':
      case 'd':
      case 'v':
      case 'e':
        devtoolsSecretCode.push($event.key);
        break;
      default:
        // Clear the array because the code was wrong
        devtoolsSecretCode.splice(0, devtoolsSecretCode.length);
    }

    if (devtoolsSecretCode.length > 0) {
      // If they type the secret code
      if (devtoolsSecretCode.join('') === '--popdev--') {
        const { showDevtools } = this.props;
        showDevtools();

        // Clear the once dialog is shown
        devtoolsSecretCode.splice(0, devtoolsSecretCode.length);
      }
    }
  };

  componentDidMount () {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.onKeyDown);
    const { hideDevtools } = this.props;
    hideDevtools();
  }

  render () {
    const { show, hideDevtools } = this.props;
    if (show) {
      return (
        <BaseDialog
          show={ show }
          title="Devtools"
          body={ (
            <div className="col">
              <Switch
                id="devToolsAlwaysNetworkError"
                checked={ Devtools.isNetworkAlwaysError() }
                text="Always return Error on network response (TODO)"
                onChange={ Devtools.setNetworkAlwaysError } />
              <Switch
                id="devToolsPopinsBreakdownEmptyState"
                checked={ Devtools.isPopinsBreakdownEmpty() }
                text="Force POPins Breakdown Empty state"
                onChange={ Devtools.setPopinsBreakdownEmpty } />
            </div>
          ) }
          onHidden={ hideDevtools }
          hideDialog={ hideDevtools }
        />
      );
    } else
      return null;
  }
}

const mapStateToProps = state => {
  return {
    show: state.dialog.devtools
  };
};

export default connect(mapStateToProps, {
  showDevtools,
  hideDevtools
})(DevtoolsDialog);
